export default __webpack_public_path__ + "static/media/how_cohortprojection.c32077d0.png";